import { useEffect } from "react";
import { useSession } from "../lib/auth";
import { setSentryUser } from "../lib/sentry";

/** Syncs auth session to Sentry user context. Mount once near app root. */
export function SentryUserSync() {
  const { data } = useSession();

  useEffect(() => {
    if (data?.user) {
      setSentryUser({ id: data.user.id, email: data.user.email });
    } else {
      setSentryUser(null);
    }
  }, [data?.user?.id, data?.user?.email]);

  return null;
}
